module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__wrap"
  }, [_c('div', {
    staticClass: "modal__body"
  }, [_c('a', {
    staticClass: "modal__close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hide.apply(null, arguments)
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('page-register-form', {
    ref: "form",
    attrs: {
      "submit-button-text": "เข้าสู่ระบบ",
      "back-button": false
    },
    on: {
      "submit": _vm.success
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f48a78f6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginModal.vue
// module id = 1238
// module chunks = 0